import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-03c23ec2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-5 col-span-2 sm:col-span-1" }
const _hoisted_2 = ["aria-selected"]
const _hoisted_3 = { class: "bg-wild-sand py-40 px-30" }
const _hoisted_4 = { class: "mt-x2 p-x1 text-left" }
const _hoisted_5 = { class: "font-bold" }
const _hoisted_6 = { class: "o-text-caption mt-2" }

import OverlaySpotPrice from '@/shared/product/customizer/ui/spots/helpers/OverlaySpotPrice.vue';
import { ComfortCustomizerModel } from '@/types/productServerApi';
import useProductDetailPage from '@/shared/product/details/useProductDetailPage';
import useCustomizer from '@/shared/product/customizer/useCustomizer';
import ProductSplashLabels from '@/shared/product/splash/ui/ProductSplashLabels.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ComfortSpot',
  props: {
    model: null
  },
  setup(__props: any) {

const props = __props as {
    model: ComfortCustomizerModel
}



const { clearActiveCustomizerOverlay } = useCustomizer();
const { updateSku } = useProductDetailPage();

const handleClick = () => {
    clearActiveCustomizerOverlay();
    updateSku(props.model.sku);
};

return (_ctx: any,_cache: any) => {
  const _component_ResponsiveImage = _resolveComponent("ResponsiveImage")!

  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("button", {
      "aria-selected": __props.model.selected,
      onClick: handleClick
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["bg-wild-sand relative px-70 py-35 md:py-25", { 'selected': __props.model.selected }])
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_ResponsiveImage, {
            "is-product-image": "",
            mode: "contain",
            "image-url": __props.model.image.path,
            alt: __props.model.name,
            "aspect-ratio": 4/3,
            "width-on-screen": 30,
            "cache-bust": __props.model.image.cacheBust
          }, null, 8, ["image-url", "alt", "cache-bust"])
        ]),
        _createVNode(ProductSplashLabels, {
          labels: [],
          selected: __props.model.selected
        }, null, 8, ["selected"])
      ], 2),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, _toDisplayString(__props.model.name), 1),
        _createVNode(OverlaySpotPrice, {
          price: __props.model.price,
          "variant-id": __props.model.sku,
          class: "my-x1"
        }, null, 8, ["price", "variant-id"]),
        _createElementVNode("p", _hoisted_6, _toDisplayString(__props.model.description), 1)
      ])
    ], 8, _hoisted_2)
  ]))
}
}

})